/* eslint import/first: 0 */
/* eslint import/newline-after-import: 0 */
/* eslint no-multi-assign: 0 */
import './jquery';
import 'bootstrap-sass';

import _ from 'lodash';
window._ = _;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';

window.axios = axios;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.defaults.baseURL = window.location.protocol + '//' + window.location.host;

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

import Pusher from 'pusher-js';

window.initPusherEcho = () => {
  if (window.Echo) { return; }

  window.Pusher = Pusher;
  window.Echo = new Echo({
    broadcaster: 'pusher',
    key: 'c6d5c69300080f889efc',
    cluster: 'us2',
  });
};

/**
 * IE Promise undefined issue
 */

import 'babel-polyfill';
